<template>
    <div class="relative">
        <div @mouseenter="show = true" @mouseleave="show = false" class="h-4 w-4 border-2 border-gray-300 rounded-full text-gray-400 flex flex-row items-center justify-center text-xs font-bold select-none cursor-pointer">
            ?
        </div>
        <div v-if="show" class="absolute w-64 flex flex-row items-start justify-start z-10" :style="{ left: 'calc(100% + 1rem)', top: '-1rem' }">
            <div class="bg-white p-4 border tooltip shadow-md">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        show: false
    })
}
</script>

<style>
.tooltip::after {
  content: " ";
  position: absolute;
  top: 1.25rem; /* At the bottom of the tooltip */
  left: 0%;
  margin-left: -10px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent #e2e8f1 transparent transparent;
}
</style>